export * from './lib/password-requirements.component';
